module.exports = {
  LANDING_PAGE: 'main-page',
  RELATED_ROUTES: [['search-tool-surname', 'search-tool-surname-detail']],
};
